import { Users } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";

const PartnershipAgreements = () => {
  const mainContent = (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold mb-6">Partnership Agreement Services</h2>
          <p className="text-lg text-muted-foreground">
            Comprehensive partnership and operating agreement drafting for Texas businesses. We create legally sound agreements that define ownership, management, profit distribution, and exit strategies to prevent future disputes.
          </p>
        </div>
      </div>
    </section>
  );
  return <GenericPracticePage title="Partnership Agreements" subtitle="Protect Your Business Relationships" icon={<Users className="h-16 w-16" />} mainContent={mainContent} />;
};
export default PartnershipAgreements;